import { TranslateService } from '@ngx-translate/core';
import { ReportFrequency, } from 'src/swagger-gen/web-secured/models';

export class SubscriptionReportingListModel {

    uid: string;
    uidSubscription!: string;
    diffusionListName?: string;
    reportName?: string;
    types?: Array<ReportFrequency>;

    constructor(subscriptionReportList: any, translate: TranslateService) {
        this.uid = subscriptionReportList?.uid;
        this.reportName = subscriptionReportList?.name;
        this.types = subscriptionReportList?.frequencies;
      }

}

